import { MinimizedArticleStyled } from "@components/Article/MiniArticle";
import DiffContent from "@components/Atoms/DiffContent";
import { DiffLinePopoverHeader } from "@ext/git/core/Diff/components/DiffLine/DiffLinePopover";
import t from "@ext/localization/locale/translate";
import type { DiffHunk } from "@ext/VersionControl/DiffHandler/model/DiffHunk";

export const BreadcrumbDiffLine = ({ changes }: { changes: DiffHunk[] }) => (
	<div className="article bg-[var(--color-article-bg)]" data-qa="diff-line-popover">
		<DiffLinePopoverHeader title={t("diff.type.breadcrumb")} />
		<div className="max-h-[50vh] overflow-auto px-3 pb-3">
			<MinimizedArticleStyled>
				<div className="article-body popup-article">
					<DiffContent
						changes={changes}
						isCode={false}
						showDiff
						unchangedColor={{ color: "var(--color-article-text)" }}
					/>
				</div>
			</MinimizedArticleStyled>
		</div>
	</div>
);
